import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import LogoImage from "assets/logo.png"
import LogoDarkImage from "assets/logo_dark.png"

const Logo = ({ colored, ...props }) => (
  <Box
    component="img"
    src={colored ? LogoDarkImage : LogoImage}
    sx={{
      aspectRatio: "1036 / 370"
    }}
    {...props}
  />
);

Logo.propTypes = {
  colored: PropTypes.bool
}

export default Logo;
